import React, { createContext, useContext, useState, ReactNode, useCallback, useMemo } from 'react';

interface UIState {
  menuOpen: boolean;
  setMenuOpen: (open: boolean) => void;
  toggleMenu: () => void;
}

const UIContext = createContext<UIState | undefined>(undefined);

export const useUI = (): UIState => {
  const context = useContext(UIContext);
  if (!context) {
    throw new Error('useUI must be used within a UIProvider');
  }
  return context;
};

interface UIProviderProps {
  children: ReactNode;
}

export const UIProvider: React.FC<UIProviderProps> = ({ children }) => {
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = useCallback(() => setMenuOpen(prev => !prev), []);

  const value: UIState = useMemo(() => ({
    menuOpen,
    setMenuOpen,
    toggleMenu,
  }), [menuOpen, toggleMenu]);

  return <UIContext.Provider value={value}>{children}</UIContext.Provider>;
};